import { ReactSVG } from "react-svg";
import PlanItemPaymentTitle from "./Title";
import PlanItemPaymentItems from "./Items";

const PlanItemPayment = ({
  id,
  title,
  price,
  plan_code,
  last_purchase_token,
  last_purchase_date,
  onToggleActivePaymentItem = () => {},
}) => {
  return (
    <div className="flex flex-col gap-10">
      <PlanItemPaymentTitle />

      <PlanItemPaymentItems
        id={id}
        price={price}
        title={title}
        plan_code={plan_code}
        last_purchase_date={last_purchase_date}
        last_purchase_token={last_purchase_token}
        onToggleActivePaymentItem={onToggleActivePaymentItem}
      />
    </div>
  );
};

export default PlanItemPayment;
